function getValidMonthYear(month, year) {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-11
    const currentYear = currentDate.getFullYear();

    // Compare the input date with current date
    const inputDate = new Date(year, month - 1); // month - 1 because Date uses 0-indexed months
    const todayDate = new Date(currentYear, currentMonth - 1);

    // If input date is less than (before) current month/year
    if (inputDate < todayDate) {
        return { month: currentMonth, year: currentYear };
    }

    // Otherwise return the input month and year
    return { month: month, year: year };
}

const MonthFormatHelper = {
    getValidMonthYear
}

export default MonthFormatHelper;
